RivalIQ.apps.Registration.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.User = Backbone.Model.extend({

        initialize: function (attrs, options) {
            const me = this;
            me.options = options;
        },

        validate: function (attributes) {

            const me = this;
            let errors;

            if (_.get(me, ['options', 'validateNameAndPassword'])) {
                const adminCreated = attributes.admin_created;
                const firstname = attributes.first_name;
                const lastname = attributes.last_name;
                const companyname = attributes.company_name;
                const companytitle = attributes.company_title;

                const password = attributes.password;
                const passwordConfirmation = attributes.passwordConfirmation;

                const termsAndConditions = attributes.terms_and_conditions;

                errors = App.utils.validateNameAndPassword(adminCreated, firstname, lastname, companyname, companytitle, password, passwordConfirmation, termsAndConditions);
            }

            return _.isEmpty(errors) ? null : errors;
        }
    });
});
